exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__Ia6wX{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__a12PU{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2a0Q-{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2DeIf{display:none!important}}.style_bodyWithSides__1xywl{display:flex;flex:1 1 auto;padding:0}@media (max-width:37.4rem){.style_bodyWithSides__1xywl{flex-direction:column}}@media (min-width:37.4rem){.style_sideBarRight__2_Hml{border-left:.0625rem solid #ccc}}@media (min-width:37.4rem){.style_sideBarLeft__V3RKB{border-right:.0625rem solid #ccc}}.style_sidebarContainer__3MmJB{flex-basis:17.6rem}.style_sideBar__3WzhS{font-size:.875rem}@media (max-width:37.4rem){.style_sideBar__3WzhS{border-top:.0625rem solid #ccc}}.style_sideBarPadding__jE6Gd{padding:0 1rem}.style_main__3txB4{flex-grow:1;flex-basis:1rem;min-width:0}@media (max-width:37.4rem){.style_main__3txB4{flex-basis:auto}}.style_overflowXHidden__Cjipd{overflow-x:hidden}.style_mainContent__2tIQ4{padding-top:0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__Ia6wX",
	"hideSm": "style_hide-sm__Ia6wX",
	"visible-sm": "style_visible-sm__a12PU",
	"visibleSm": "style_visible-sm__a12PU",
	"hide-md": "style_hide-md__2a0Q-",
	"hideMd": "style_hide-md__2a0Q-",
	"visible-md": "style_visible-md__2DeIf",
	"visibleMd": "style_visible-md__2DeIf",
	"bodyWithSides": "style_bodyWithSides__1xywl",
	"sideBarRight": "style_sideBarRight__2_Hml",
	"sideBarLeft": "style_sideBarLeft__V3RKB",
	"sidebarContainer": "style_sidebarContainer__3MmJB",
	"sideBar": "style_sideBar__3WzhS",
	"sideBarPadding": "style_sideBarPadding__jE6Gd",
	"main": "style_main__3txB4",
	"overflowXHidden": "style_overflowXHidden__Cjipd",
	"mainContent": "style_mainContent__2tIQ4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SidebarLayout/style.less
// module id = 1566
// module chunks = 8